import { flattenProp } from 'recompose'
import { unbookableBtnUrlSelector, unbookableBtnTypeSelector } from 'settings/selectors'
import { setActiveLocation, setHoveredLocation } from 'map/actions'
import {
    locationSelector,
    locationRatesSelector,
    bookingUrlSelector,
    carParkUrlSelector,
    carParPhoneSelector,
    brandSelector,
    rateLabelSelector,
    canBuySelector,
    buyLabelTranslationSelector,
    externalSeasonTicketUrlSelector,
} from 'map/selectors'
import ResultsListItem from 'map/components/resultsListItem/ResultsListItem'
import ResultsListItemActionButton from 'map/components/actionButton/ResultsListItemActionButton'

const ResultsListItemContainer = ({
    name,
    services,
    rate,
    canBuy,
    carParkUrl,
    bookingUrl,
    buyLabel,
    opngo,
    unbookableBtnUrl,
    unbookableBtnType,
    phone,
    externalSeasonTicketUrl,
    $brand,
    active,
    sfLocationId,
    setHoveredLocation,
    setActiveLocation,
    geoLocation,
    translate,
}) => {
    const onMouseEnter = () => {
        setHoveredLocation(sfLocationId)
    }

    const onMouseLeave = () => {
        setHoveredLocation(null)
    }

    const onClick = () => {
        setActiveLocation(sfLocationId, false, { lat: geoLocation.x, lng: geoLocation.y })
    }

    return (
        <ResultsListItem
            translate={translate}
            name={name}
            services={services}
            carParkUrl={carParkUrl}
            onClick={onClick}
            active={active}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            renderOperator={() =>
                $brand &&
                $brand.logo && (
                    <span className="operator">
                        <Image image={$brand.logo} title={$brand} />
                    </span>
                )
            }>
            <ResultsListItemActionButton
                canBuy={canBuy}
                opngo={opngo}
                externalSeasonTicketUrl={externalSeasonTicketUrl}
                rate={rate}
                bookingUrl={bookingUrl}
                buyLabel={buyLabel}
                phone={phone}
                unbookableBtnType={unbookableBtnType}
                carParkUrl={carParkUrl}
                unbookableBtnUrl={unbookableBtnUrl}
            />
        </ResultsListItem>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            location: locationSelector,
            canBuy: canBuySelector,
            rates: locationRatesSelector,
            bookingUrl: bookingUrlSelector,
            carParkUrl: carParkUrlSelector,
            rate: rateLabelSelector,
            buyLabel: buyLabelTranslationSelector,
            $brand: brandSelector,
            unbookableBtnUrl: unbookableBtnUrlSelector,
            unbookableBtnType: unbookableBtnTypeSelector,
            phone: carParPhoneSelector,
            externalSeasonTicketUrl: externalSeasonTicketUrlSelector,
        }),
        {
            setActiveLocation,
            setHoveredLocation,
        }
    ),
    flattenProp('location')
)(ResultsListItemContainer)
